// import Banner from "../components/Banner";
// import Header from "../components/Header/Header";
// import Modal from "../components/Modal";
import Row from "../components/Row/Row";

const NewHome = ({ netflixOriginals }) => {
  const trendingNow = [
    {
      adult: false,
      backdrop_path: "/sNLP0dLZcVBqYa3MchCXJqgDtFb.jpg",
      id: 119051,
      name: "Wednesday",
      original_language: "en",
      original_name: "Wednesday",
      overview:
        "Wednesday Addams is sent to Nevermore Academy, a bizarre boarding school where she attempts to master her psychic powers, stop a monstrous killing spree of the town citizens, and solve the supernatural mystery that affected her family 25 years ago — all while navigating her new relationships.",
      poster_path: "/9PFonBhy4cQy7Jz20NpMygczOkv.jpg",
      media_type: "tv",
      genre_ids: [10765, 9648, 35],
      popularity: 7442.397,
      first_air_date: "2022-11-23",
      vote_average: 8.8,
      vote_count: 2653,
      origin_country: ["US"],
    },
    {
      adult: false,
      backdrop_path: "/bQXAqRx2Fgc46uCVWgoPz5L5Dtr.jpg",
      id: 436270,
      title: "Black Adam",
      original_language: "en",
      original_title: "Black Adam",
      overview:
        "Nearly 5,000 years after he was bestowed with the almighty powers of the Egyptian gods—and imprisoned just as quickly—Black Adam is freed from his earthly tomb, ready to unleash his unique form of justice on the modern world.",
      poster_path: "/pFlaoHTZeyNkG83vxsAJiGzfSsa.jpg",
      media_type: "movie",
      genre_ids: [28, 14, 878],
      popularity: 6345.586,
      release_date: "2022-10-19",
      video: false,
      vote_average: 7.3,
      vote_count: 2694,
    },
    {
      adult: false,
      backdrop_path: "/e782pDRAlu4BG0ahd777n8zfPzZ.jpg",
      id: 555604,
      title: "Guillermo del Toro's Pinocchio",
      original_language: "en",
      original_title: "Guillermo del Toro's Pinocchio",
      overview:
        "During the rise of fascism in Mussolini's Italy, a wooden boy brought magically to life struggles to live up to his father's expectations.",
      poster_path: "/vx1u0uwxdlhV2MUzj4VlcMB0N6m.jpg",
      media_type: "movie",
      genre_ids: [16, 14, 18],
      popularity: 311.977,
      release_date: "2022-11-09",
      video: false,
      vote_average: 8.5,
      vote_count: 289,
    },
    {
      adult: false,
      backdrop_path: "/53BC9F2tpZnsGno2cLhzvGprDYS.jpg",
      id: 736526,
      title: "Troll",
      original_language: "no",
      original_title: "Troll",
      overview:
        "Deep inside the mountain of Dovre, something gigantic awakens after being trapped for a thousand years. Destroying everything in its path, the creature is fast approaching the capital of Norway. But how do you stop something you thought only existed in Norwegian folklore?",
      poster_path: "/9z4jRr43JdtU66P0iy8h18OyLql.jpg",
      media_type: "movie",
      genre_ids: [14, 28, 12],
      popularity: 5925.235,
      release_date: "2022-12-01",
      video: false,
      vote_average: 6.778,
      vote_count: 518,
    },
    {
      adult: false,
      backdrop_path: "/rfnmMYuZ6EKOBvQLp2wqP21v7sI.jpg",
      id: 774752,
      title: "The Guardians of the Galaxy Holiday Special",
      original_language: "en",
      original_title: "The Guardians of the Galaxy Holiday Special",
      overview:
        "On a mission to make Christmas unforgettable for Quill, the Guardians head to Earth in search of the perfect present.",
      poster_path: "/8dqXyslZ2hv49Oiob9UjlGSHSTR.jpg",
      media_type: "movie",
      genre_ids: [35, 878, 12],
      popularity: 1083.464,
      release_date: "2022-11-25",
      video: false,
      vote_average: 7.462,
      vote_count: 710,
    },
    {
      adult: false,
      backdrop_path: "/ypFD4TJ3nLJesou76V59CnweaT0.jpg",
      id: 715931,
      title: "Emancipation",
      original_language: "en",
      original_title: "Emancipation",
      overview:
        "Inspired by the gripping true story of a man who would do anything for his family—and for freedom. When Peter, an enslaved man, risks his life to escape and return to his family, he embarks on a perilous journey of love and endurance.",
      poster_path: "/s9sUK1vAaOcxJfKzNTszrNkPhkH.jpg",
      media_type: "movie",
      genre_ids: [36, 18, 9648, 53, 28],
      popularity: 115.508,
      release_date: "2022-12-02",
      video: false,
      vote_average: 8.024,
      vote_count: 143,
    },
    {
      adult: false,
      backdrop_path: "/198vrF8k7mfQ4FjDJsBmdQcaiyq.jpg",
      id: 76600,
      title: "Avatar: The Way of Water",
      original_language: "en",
      original_title: "Avatar: The Way of Water",
      overview:
        "Set more than a decade after the events of the first film, learn the story of the Sully family (Jake, Neytiri, and their kids), the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
      poster_path: "/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg",
      media_type: "movie",
      genre_ids: [878, 28, 12],
      popularity: 1187.763,
      release_date: "2022-12-14",
      video: false,
      vote_average: 8.536,
      vote_count: 28,
    },
    {
      adult: false,
      backdrop_path: "/xDMIl84Qo5Tsu62c9DGWhmPI67A.jpg",
      id: 505642,
      title: "Black Panther: Wakanda Forever",
      original_language: "en",
      original_title: "Black Panther: Wakanda Forever",
      overview:
        "Queen Ramonda, Shuri, M’Baku, Okoye and the Dora Milaje fight to protect their nation from intervening world powers in the wake of King T’Challa’s death. As the Wakandans strive to embrace their next chapter, the heroes must band together with the help of War Dog Nakia and Everett Ross and forge a new path for the kingdom of Wakanda.",
      poster_path: "/ps2oKfhY6DL3alynlSqY97gHSsg.jpg",
      media_type: "movie",
      genre_ids: [28, 12, 878],
      popularity: 2145.973,
      release_date: "2022-11-09",
      video: false,
      vote_average: 7.559,
      vote_count: 1294,
    },
    {
      adult: false,
      backdrop_path: "/93SxdkiR3gBcbG5FxIt0DCBttul.jpg",
      id: 111837,
      name: "Willow",
      original_language: "en",
      original_name: "Willow",
      overview:
        "Many years after the events of the original film, legendary sorcerer Willow leads a group of misfit heroes on a dangerous rescue mission through a world beyond their wildest imaginations.",
      poster_path: "/jhdSPDlhswjN1r6O0pGP3ZvQgU8.jpg",
      media_type: "tv",
      genre_ids: [10765, 10759, 18],
      popularity: 1458.014,
      first_air_date: "2022-11-30",
      vote_average: 5.902,
      vote_count: 51,
      origin_country: ["US"],
    },
    {
      adult: false,
      backdrop_path: "/79PcXPpbDWql74h8Y00mNwbYMbS.jpg",
      id: 664469,
      title: "Amsterdam",
      original_language: "en",
      original_title: "Amsterdam",
      overview:
        "In the 1930s, three friends—a doctor, a nurse, and an attorney—witness a murder, become suspects themselves and uncover one of the most outrageous plots in North American history.",
      poster_path: "/6sJcVzGCwrDCBMV0DU6eRzA2UxM.jpg",
      media_type: "movie",
      genre_ids: [80, 35, 36, 9648, 53],
      popularity: 182.771,
      release_date: "2022-09-27",
      video: false,
      vote_average: 6.138,
      vote_count: 447,
    },
    {
      adult: false,
      backdrop_path: "/8ybdSPM1AutUK48gmMPOfu8TcyB.jpg",
      id: 518896,
      title: "Warriors of Future",
      original_language: "zh",
      original_title: "明日戰記",
      overview:
        "When a meteor carrying a destructive plant strikes the world, a suicide squad is given hours to save their post-apocalyptic city from total collapse.",
      poster_path: "/2l9LbxBSkJseoxYcIJjclnmxyq.jpg",
      media_type: "movie",
      genre_ids: [18, 28, 878],
      popularity: 350.151,
      release_date: "2022-08-05",
      video: false,
      vote_average: 7.417,
      vote_count: 168,
    },
    {
      adult: false,
      backdrop_path: "/s1xnjbOIQtwGObPnydTebp74G2c.jpg",
      id: 90669,
      name: "1899",
      original_language: "de",
      original_name: "1899",
      overview:
        "Passengers on an immigrant ship traveling to the new continent get caught in a mysterious riddle when they find a second vessel adrift on the open sea.",
      poster_path: "/5rLmJKbHBsGAoCjqiEIdsejlf5Q.jpg",
      media_type: "tv",
      genre_ids: [9648, 18],
      popularity: 962.719,
      first_air_date: "2022-11-17",
      vote_average: 7.922,
      vote_count: 503,
      origin_country: ["DE"],
    },
    {
      adult: false,
      backdrop_path: "/hIZFG7MK4leU4axRFKJWqrjhmxZ.jpg",
      id: 95403,
      name: "The Peripheral",
      original_language: "en",
      original_name: "The Peripheral",
      overview:
        "Stuck in a small Appalachian town, a young woman’s only escape from the daily grind is playing advanced video games. She is such a good player that a company sends her a new video game system to test…but it has a surprise in store. It unlocks all of her dreams of finding a purpose, romance, and glamour in what seems like a game…but it also puts her and her family in real danger.",
      poster_path: "/ccBe5BVeibdBEQU7l6P6BubajWV.jpg",
      media_type: "tv",
      genre_ids: [10765, 18],
      popularity: 728.982,
      first_air_date: "2022-10-20",
      vote_average: 8.117,
      vote_count: 402,
      origin_country: ["US"],
    },
    {
      adult: false,
      backdrop_path: "/c1bz69r0v065TGFA5nqBiKzPDys.jpg",
      id: 830784,
      title: "Lyle, Lyle, Crocodile",
      original_language: "en",
      original_title: "Lyle, Lyle, Crocodile",
      overview:
        "When the Primm family moves to New York City, their young son Josh struggles to adapt to his new school and new friends. All of that changes when he discovers Lyle — a singing crocodile who loves baths, caviar and great music — living in the attic of his new home. But when Lyle’s existence is threatened by evil neighbor Mr. Grumps, the Primms must band together to show the world that family can come from the most unexpected places.",
      poster_path: "/irIS5Tn3TXjNi1R9BpWvGAN4CZ1.jpg",
      media_type: "movie",
      genre_ids: [35, 10751, 10402],
      popularity: 977.901,
      release_date: "2022-10-07",
      video: false,
      vote_average: 7.982,
      vote_count: 164,
    },
    {
      adult: false,
      backdrop_path: "/7zQJYV02yehWrQN6NjKsBorqUUS.jpg",
      id: 724495,
      title: "The Woman King",
      original_language: "en",
      original_title: "The Woman King",
      overview:
        "The story of the Agojie, the all-female unit of warriors who protected the African Kingdom of Dahomey in the 1800s with skills and a fierceness unlike anything the world has ever seen, and General Nanisca as she trains the next generation of recruits and readies them for battle against an enemy determined to destroy their way of life.",
      poster_path: "/lQMJHnHxUyj8kJlC2YOKNuzuwMP.jpg",
      media_type: "movie",
      genre_ids: [28, 18, 36],
      popularity: 3828.35,
      release_date: "2022-09-15",
      video: false,
      vote_average: 7.865,
      vote_count: 698,
    },
    {
      adult: false,
      backdrop_path: "/AaV1YIdWKnjAIAOe8UUKBFm327v.jpg",
      id: 361743,
      title: "Top Gun: Maverick",
      original_language: "en",
      original_title: "Top Gun: Maverick",
      overview:
        "After more than thirty years of service as one of the Navy’s top aviators, and dodging the advancement in rank that would ground him, Pete “Maverick” Mitchell finds himself training a detachment of TOP GUN graduates for a specialized mission the likes of which no living pilot has ever seen.",
      poster_path: "/62HCnUTziyWcpDaBO2i1DX17ljH.jpg",
      media_type: "movie",
      genre_ids: [28, 18],
      popularity: 541.009,
      release_date: "2022-05-24",
      video: false,
      vote_average: 8.347,
      vote_count: 4987,
    },
    {
      adult: false,
      backdrop_path: "/ajztm40qDPqMONaSJhQ2PaNe2Xd.jpg",
      id: 83867,
      name: "Star Wars: Andor",
      original_language: "en",
      original_name: "Star Wars: Andor",
      overview:
        "The tale of the burgeoning rebellion against the Empire and how people and planets became involved. In an era filled with danger, deception and intrigue, Cassian Andor embarks on the path that is destined to turn him into a rebel hero.",
      poster_path: "/59SVNwLfoMnZPPB6ukW6dlPxAdI.jpg",
      media_type: "tv",
      genre_ids: [10765, 10759, 10768],
      popularity: 312.811,
      first_air_date: "2022-09-21",
      vote_average: 8.106,
      vote_count: 400,
      origin_country: ["US"],
    },
    {
      adult: false,
      backdrop_path: "/6tAYyCxF0T5oUIH95zMBC3X3W5T.jpg",
      id: 668461,
      title: "Slumberland",
      original_language: "en",
      original_title: "Slumberland",
      overview:
        "A young girl discovers a secret map to the dreamworld of Slumberland, and with the help of an eccentric outlaw, she traverses dreams and flees nightmares, with the hope that she will be able to see her late father again.",
      poster_path: "/eCgBLNAFC4XDZ4DiyQ80PIJdSHU.jpg",
      media_type: "movie",
      genre_ids: [10751, 14, 12, 18],
      popularity: 640.715,
      release_date: "2022-11-09",
      video: false,
      vote_average: 7.776,
      vote_count: 388,
    },
    {
      adult: false,
      backdrop_path: "/dGOhplPZTL0SKyb0ocTFBHIuKUC.jpg",
      id: 68507,
      name: "His Dark Materials",
      original_language: "en",
      original_name: "His Dark Materials",
      overview:
        "Lyra is an orphan who lives in a parallel universe in which science, theology and magic are entwined. Her search for a kidnapped friend uncovers a sinister plot involving stolen children, and turns into a quest to understand a mysterious phenomenon called Dust. She is later joined on her journey by Will, a boy who possesses a knife that can cut windows between worlds. As she learns the truth about her parents and her prophesied destiny, the two young people are caught up in a war against celestial powers that ranges across many worlds.",
      poster_path: "/1ljcoM9hFNiXpcoevZQwwc7oCYT.jpg",
      media_type: "tv",
      genre_ids: [10765, 18],
      popularity: 312.39,
      first_air_date: "2019-11-03",
      vote_average: 8,
      vote_count: 1215,
      origin_country: ["GB"],
    },
  ];

  return (
    <div
      className={`relative h-screen lg:h-[140vh]`} // ${
      //     showModal && "!h-screen overflow-hidden"
      //   }`}
    >
      <main className="relative pl-4 pb-24 lg:space-y-24 lg:pl-16">
        {/* <Banner netflixOriginals={netflixOriginals} /> */}
        <section className="md:space-y-24">
          <Row title="Trending Now" movies={trendingNow} />
          {/* <Row title="Top Rated" movies={trendingNow} />
          <Row title="Action Movies" movies={trendingNow} /> */}
        </section>
      </main>

      {/* {showModal && <Modal />} */}
    </div>
  );
};

export default NewHome;
